import "./App.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Quiz from "./pages/Quiz/Quiz";
import NotFound from "./pages/NotFound/NotFound";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Quiz />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
